<template>
    <p :class="[pClass, { invalid: isInvalid }]">
        <input type="checkbox"
               :id="id"
               :name="name"
               :value="val"
               v-model="checked"
               @change="onChange"
               :disabled="disabled"
        >
        <label :for="id" :class="{disabled: disabled}">
            <slot></slot>
          <span v-if="helpText"> ({{ helpText }})</span> <slot name="afterText"></slot>
        </label>
        <input v-if="withSubmit" type="submit" class="btn" :value="'Uložit' | translate" @click.prevent.stop="$emit('submit')">
    </p>
</template>

<script>
	export default {
		name: "CheckboxInput",
		props: {
			id: [String, Number],
			name: String,
			val: [String, Number, Boolean, Array],
			value: [String, Number, Boolean, Array],
			pClass: {
				type: String,
				default: 'field'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			withSubmit: {
				type: Boolean,
				default: false
			},
      helpText: {
        type: String,
        default: ''
      },
		},
		data: function () {
			return {
				checkedProxy: false,
				forcedInvalid: false,
				invalidText: null,
			}
		},
		computed: {
			checked: {
				get() {
					return this.value
				},
				set(val) {
					this.checkedProxy = val
				}
			},
			isInvalid() {
				return (this.required && !this.value) || this.isForcedInvalid
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			onChange: function (e) {
				this.$emit('input', this.checkedProxy)
			},
            setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/CheckboxInput.vue